<template>
  <div class="chart-area">
  {{ id }}
  <ApexCharts
    height="400px"
    width="700px"
    :options="chartOptions"
    :series="data.series"
  />
</div>
</template>

<script>

import VueApexCharts from "vue3-apexcharts";

export default {
  name: 'TrainingChartSingle',
  components: {
    ApexCharts: VueApexCharts,
  },
  props: {
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: {},
    },
    name: {
      type: String,
      default: '',
    },
    series: {
      type: Object,
      default: () => {},
    },
    labels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isZoomed: false,
      
      // chartOptions: {
      //   chart: {
      //     height: 350,
      //     type: 'this.data.chart.type',
      //     zoom: {
      //       enabled: false,
      //     },
      //     animations: {
      //       enabled: false,
      //     },
      //   },
      //   stroke: {
      //     width: 2,
      //   },
      //   markers: {
      //     size: [4],
      //   },
      //   labels: 'this.data.xaxis',
      //   title: {
      //     text: this.name,
      //     align: 'center',
      //   },
      //   xaxis: {
      //     tickAmount: this.labels.length / 10,
      //   },
      //   yaxis: {
      //     decimalsInFloat: 4,
      //   },

      // },
    };
  },
  computed: {
    chartOptions() {

      var v=this.data;

      // if (v.chart.type!='line') {
      //   return {};
      // }

      //v['chart']['height']=350;
     
      console.log(v);

      if (!('chart' in v)) return {};
      
      v.chart.height=550;
      // v.yaxis.decimalsInFloat=4;



      return v; 
    }
  },
  created() {

  },
  mounted() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 500);
  },
  methods: {
    clicked() {
      this.$emit('chart-clicked');
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-area {
  display: flex;
  flex-direction: column;
  align-items: center;

}


</style>
